module.exports = __webpack_public_path__ + "img/googleplay.5786b078.png";